export default __webpack_public_path__ + "static/media/dashboardWasher.a08bba2f.png";